export default __webpack_public_path__ + "static/media/equipment.55784c42.png";